/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateRequestBody =
  {
    organizationId?: string | undefined;
    tenantId?: string | undefined;
    keyId?: string | undefined;
  };

export const PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateStatus =
  {
    StatusUnspecified: "STATUS_UNSPECIFIED",
    StatusActive: "STATUS_ACTIVE",
    StatusSuspended: "STATUS_SUSPENDED",
    StatusPendingVerification: "STATUS_PENDING_VERIFICATION",
    StatusRevoked: "STATUS_REVOKED",
    StatusExpired: "STATUS_EXPIRED",
    StatusRateLimited: "STATUS_RATE_LIMITED",
    StatusPendingReview: "STATUS_PENDING_REVIEW",
    StatusDeprecated: "STATUS_DEPRECATED",
    StatusMaintenance: "STATUS_MAINTENANCE",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateStatus =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateStatus
  >;

export const PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateScopes =
  {
    TenantApiKeyScopeUnspecified: "TENANT_API_KEY_SCOPE_UNSPECIFIED",
    TenantApiKeyScopeReadJobs: "TENANT_API_KEY_SCOPE_READ_JOBS",
    TenantApiKeyScopeReadLeads: "TENANT_API_KEY_SCOPE_READ_LEADS",
    TenantApiKeyScopeReadWorkflows: "TENANT_API_KEY_SCOPE_READ_WORKFLOWS",
    TenantApiKeyScopeReadAnalytics: "TENANT_API_KEY_SCOPE_READ_ANALYTICS",
    TenantApiKeyScopeReadSettings: "TENANT_API_KEY_SCOPE_READ_SETTINGS",
    TenantApiKeyScopeWriteJobs: "TENANT_API_KEY_SCOPE_WRITE_JOBS",
    TenantApiKeyScopeWriteLeads: "TENANT_API_KEY_SCOPE_WRITE_LEADS",
    TenantApiKeyScopeWriteWorkflows: "TENANT_API_KEY_SCOPE_WRITE_WORKFLOWS",
    TenantApiKeyScopeWriteSettings: "TENANT_API_KEY_SCOPE_WRITE_SETTINGS",
    TenantApiKeyScopeDeleteJobs: "TENANT_API_KEY_SCOPE_DELETE_JOBS",
    TenantApiKeyScopeDeleteLeads: "TENANT_API_KEY_SCOPE_DELETE_LEADS",
    TenantApiKeyScopeDeleteWorkflows: "TENANT_API_KEY_SCOPE_DELETE_WORKFLOWS",
    TenantApiKeyScopeExportData: "TENANT_API_KEY_SCOPE_EXPORT_DATA",
    TenantApiKeyScopeManageKeys: "TENANT_API_KEY_SCOPE_MANAGE_KEYS",
    TenantApiKeyScopeBillingRead: "TENANT_API_KEY_SCOPE_BILLING_READ",
    TenantApiKeyScopeBillingWrite: "TENANT_API_KEY_SCOPE_BILLING_WRITE",
    TenantApiKeyScopeAdmin: "TENANT_API_KEY_SCOPE_ADMIN",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateScopes =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateScopes
  >;

export type PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateNewApiKey =
  {
    id?: string | undefined;
    keyHash?: string | undefined;
    keyPrefix?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    status?:
      | PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateStatus
      | undefined;
    scopes?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateScopes
      >
      | undefined;
    maxUses?: number | undefined;
    allowedIps?: Array<string> | undefined;
    useCount?: number | undefined;
    expiresAt?: Date | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

/**
 * Rotates a tenant API key while maintaining its configuration
 */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateResponseBody =
  {
    newApiKey?:
      | PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateNewApiKey
      | undefined;
    newKeyValue?: string | undefined;
    oldKeyExpiry?: Date | undefined;
    tenantId?: string | undefined;
    organizationId?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateRequestBody$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateRequestBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    organizationId: z.string().optional(),
    tenantId: z.string().optional(),
    keyId: z.string().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateRequestBody$Outbound =
  {
    organizationId?: string | undefined;
    tenantId?: string | undefined;
    keyId?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateRequestBody$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateRequestBody$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateRequestBody
  > = z.object({
    organizationId: z.string().optional(),
    tenantId: z.string().optional(),
    keyId: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateRequestBody$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateRequestBody$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateRequestBody$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateRequestBody$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateRequestBody$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateRequestBody$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateRequestBody$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateRequestBodyToJSON(
  postApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateRequestBody:
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateRequestBody,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateRequestBody$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateRequestBody,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateRequestBodyFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateRequestBody,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateRequestBody$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateRequestBody' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateStatus$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateStatus
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateStatus,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateStatus$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateStatus
  > =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateStatus$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateStatus$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateStatus$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateStatus$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateStatus$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateStatus$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateScopes$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateScopes
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateScopes,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateScopes$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateScopes
  > =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateScopes$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateScopes$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateScopes$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateScopes$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateScopes$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateScopes$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateNewApiKey$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateNewApiKey,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    keyHash: z.string().optional(),
    keyPrefix: z.string().optional(),
    name: z.string().optional(),
    description: z.string().optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateStatus$inboundSchema
        .default("STATUS_UNSPECIFIED"),
    scopes: z.array(
      PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateScopes$inboundSchema,
    ).optional(),
    maxUses: z.number().int().optional(),
    allowedIps: z.array(z.string()).optional(),
    useCount: z.number().int().optional(),
    expiresAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateNewApiKey$Outbound =
  {
    id?: string | undefined;
    keyHash?: string | undefined;
    keyPrefix?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    status: string;
    scopes?: Array<string> | undefined;
    maxUses?: number | undefined;
    allowedIps?: Array<string> | undefined;
    useCount?: number | undefined;
    expiresAt?: string | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateNewApiKey$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateNewApiKey$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateNewApiKey
  > = z.object({
    id: z.string().optional(),
    keyHash: z.string().optional(),
    keyPrefix: z.string().optional(),
    name: z.string().optional(),
    description: z.string().optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateStatus$outboundSchema
        .default("STATUS_UNSPECIFIED"),
    scopes: z.array(
      PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateScopes$outboundSchema,
    ).optional(),
    maxUses: z.number().int().optional(),
    allowedIps: z.array(z.string()).optional(),
    useCount: z.number().int().optional(),
    expiresAt: z.date().transform(v => v.toISOString()).optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateNewApiKey$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateNewApiKey$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateNewApiKey$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateNewApiKey$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateNewApiKey$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateNewApiKey$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateNewApiKey$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateNewApiKeyToJSON(
  postApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateNewApiKey:
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateNewApiKey,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateNewApiKey$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateNewApiKey,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateNewApiKeyFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateNewApiKey,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateNewApiKey$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateNewApiKey' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateResponseBody$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    newApiKey: z.lazy(() =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateNewApiKey$inboundSchema
    ).optional(),
    newKeyValue: z.string().optional(),
    oldKeyExpiry: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    tenantId: z.string().optional(),
    organizationId: z.string().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateResponseBody$Outbound =
  {
    newApiKey?:
      | PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateNewApiKey$Outbound
      | undefined;
    newKeyValue?: string | undefined;
    oldKeyExpiry?: string | undefined;
    tenantId?: string | undefined;
    organizationId?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateResponseBody$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateResponseBody$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateResponseBody
  > = z.object({
    newApiKey: z.lazy(() =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateNewApiKey$outboundSchema
    ).optional(),
    newKeyValue: z.string().optional(),
    oldKeyExpiry: z.date().transform(v => v.toISOString()).optional(),
    tenantId: z.string().optional(),
    organizationId: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateResponseBody$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateResponseBody$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateResponseBody$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateResponseBody$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateResponseBody$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateResponseBody$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateResponseBody$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateResponseBodyToJSON(
  postApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateResponseBody:
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateResponseBody,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateResponseBody$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateResponseBody,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateResponseBody,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateResponseBody$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateResponseBody' from JSON`,
  );
}
